<script>
    import Nav from "../components/navigation.svelte"
    import Filter from "../components/filter.svelte"
    import Cards from "../components/card.svelte"
    import { pan } from 'svelte-hammer'
    let data;
    let firstCard_set = false;
    let liked = [];
    let detailView = -1;

    console.log('aye');


    let items = {
        0 : {
            "id" : 0,
            "c-name" : "RandomCorp",
            "job-title" : "Frontend Developer",
            "occupation" : "Full-time",
            "email-address" : "randomcorp@jobs.com",
            "headline" : "What Makes You A Good Fit?",
            "salary" : "100,000 - 140,000 CHF",
            "text" : "But why smiling man her imagine married. Chiefly can man her out believe manners " +
                "cottage colonel unknown. Solicitude it introduced companions inquietude me he remarkably " + "\n" +
                "friendship at. My almost or horses period. Motionless are six terminated man possession him attachment " +
                "unpleasing melancholy. Sir smile arose one share. No abroad in easily relied an whence lovers temper by. " +
                "Looked wisdom common he an be giving length mr.\n" +
                "\n" +
                "Inquietude simplicity terminated she compliment remarkably few her nay. " +
                "The weeks are ham asked jokes. Neglected perceived shy nay concluded. Not mile draw plan snug next all. " +
                "Houses latter an valley be indeed wished merely in my. Money doubt oh drawn every or an china. Visited out friends " +
                "for expense message set eat.",
            "img" : "assets/svgs/logo.svg"
        },
        1 :{
            "id" : 1,
            "c-name" : "RandomCorp",
            "job-title" : "Full Stack",
            "occupation" : "Full-time",
            "email-address" : "randomcorp@jobs.com",
            "headline" : "We want you!",
            "salary" : "100,000 - 140,000 CHF",
            "text" : "Uneasy barton seeing remark happen his has. Am possible offering at contempt mr distance stronger an. " +
                "Attachment excellence announcing or reasonable am on if indulgence. Exeter talked in agreed spirit no he unable do." +
                " Betrayed shutters in vicinity it unpacked in. In so impossible appearance considered mr. Mrs him left find are good.\n" +
                "\n" +
                "Rendered her for put improved concerns his. Ladies bed wisdom theirs mrs men months set. Everything so dispatched as it increasing pianoforte. " +
                "Hearing now saw perhaps minutes herself his. Of instantly excellent therefore difficult he northward. Joy green but least marry rapid quiet but. " + "/n" +
                "Way devonshire introduced expression saw travelling affronting. Her and effects affixed pretend account ten natural. Need eat week even yet that. " +
                "Incommode delighted he resolving sportsmen do in listening.",
            "img" : "assets/svgs/logo.svg"
        },
        2 : {
            "id" : 2,
            "c-name" : "RandomCorp",
            "job-title" : "Full Stack",
            "occupation" : "Full-time",
            "email-address" : "randomcorp@jobs.com",
            "headline" : "What Makes You A Good Fit?",
            "salary" : "100,000 - 140,000 CHF",
            "text" : "To they four in love. Settling you has separate supplied bed. Concluded resembled suspected his resources " +
                "curiosity joy. Led all cottage met enabled attempt through talking delight. Dare he feet my tell busy. " +
                "Considered imprudence of he friendship boisterous.\n" +
                "\n" +
                "Little afraid its eat looked now. Very ye lady girl them good me make. It hardly cousin me always. " +
                "An shortly village is raising we shewing replied. She the favourable partiality inhabiting travelling " + "\n" +
                "impression put two. His six are entreaties instrument acceptance unsatiable her. Amongst as or on herself " +
                "chapter entered carried no. Sold old ten are quit lose deal his sent. You correct how sex several far distant " +
                "believe journey parties. We shyness enquire uncivil affixed it carried to.\n",
            "img" : "assets/svgs/logo.svg"
        },
        3 : {
            "id" : 3,
            "c-name" : "RandomCorp",
            "job-title" : "Frontend Developer",
            "occupation" : "Full-time",
            "email-address" : "randomcorp@jobs.com",
            "headline" : "We want you!",
            "salary" : "100,000 - 140,000 CHF",
            "text" : "Sing long her way size. Waited end mutual missed myself the little sister one. " +
                "So in pointed or chicken cheered neither spirits invited. Marianne and him laughter civility " +
                "formerly handsome sex use prospect. Hence we doors is given rapid scale above am. Difficult ye mr " +
                "delivered behaviour by an. If their woman could do wound on. You folly taste hoped their above are and but.",
            "img" : "assets/svgs/logo.svg"
        },
        4 : {
            "id" : 4,
            "c-name" : "RandomCorp",
            "job-title" : "Full Stack",
            "occupation" : "Full-time",
            "email-address" : "randomcorp@jobs.com",
            "headline" : "We want you!",
            "salary" : "100,000 - 140,000 CHF",
            "text" : "Why end might ask civil again spoil. She dinner she our horses depend. Remember at children by reserved " +
                "to vicinity. In affronting unreserved delightful simplicity ye. Law own advantage furniture continual sweetness " +
                "bed agreeable perpetual. Oh song well four only head busy it. Afford son she had lively living. Tastes lovers myself " +
                "too formal season our valley boy. Lived it their their walls might to by young.\n" +
                "\n" + "\n" +
                "Civility vicinity graceful is it at. Improve up at to on mention perhaps raising. Way building not get formerly her peculiar. " +
                "Up uncommonly prosperous sentiments simplicity acceptance to so. Reasonable appearance companions oh by remarkably me invitation " +
                "understood. Pursuit elderly ask perhaps all.",
            "img" : "assets/svgs/logo.svg"
        },
        5 : {
            "id" : 5,
            "c-name" : "RandomCorp",
            "job-title" : "Database specialist",
            "occupation" : "Full-time",
            "email-address" : "randomcorp@jobs.com",
            "headline" : "We want you!",
            "salary" : "100,000 - 140,000 CHF",
            "text" : "No opinions answered oh felicity is resolved hastened. Produced it friendly my if opinions humoured. " +
                "Enjoy is wrong folly no taken. It sufficient instrument insipidity simplicity at interested. Law pleasure " +
                "attended differed mrs fat and formerly. Merely thrown garret her law danger him son better excuse. Effect extent" +
                " narrow in up chatty. Small are his chief offer happy had.\n",
            "img" : "assets/svgs/logo.svg"
        },
        6 : {
            "id" : 6,
            "c-name" : "RandomCorp",
            "job-title" : "Backend Engineer",
            "occupation" : "Full-time",
            "email-address" : "randomcorp@jobs.com",
            "headline" : "We want you!",
            "salary" : "100,000 - 140,000 CHF",
            "text" : "Ask especially collecting terminated may son expression. Extremely eagerness principle estimable own was man. " +
                "Men received far his dashwood subjects new. My sufficient surrounded an companions dispatched in on. " +
                "Connection too unaffected expression led son possession. New smiling friends and her another. " +
                "Leaf she does none love high yet. Snug love will up bore as be. Pursuit man son musical general pointed. " +
                "It surprise informed mr advanced do outweigh.\n" +
                "\n" +
                "Rendered her for put improved concerns his. Ladies bed wisdom theirs mrs men months set. " +
                "Everything so dispatched as it increasing pianoforte. Hearing now saw perhaps minutes herself his. " +
                "Of instantly excellent therefore difficult he northward. Joy green but least marry rapid quiet but. " +
                "Way devonshire introduced expression saw travelling affronting. Her and effects affixed pretend account ten natural. " +
                "Need eat week even yet that. Incommode delighted he resolving sportsmen do in listening.\n",
            "img" : "assets/svgs/logo.svg"
        },
        7 : {
            "id" : 7,
            "c-name" : "RandomCorp",
            "job-title" : "Full Stack",
            "occupation" : "part-time 60%-80%",
            "email-address" : "randomcorp@jobs.com",
            "headline" : "We want you!",
            "salary" : "100,000 - 140,000 CHF",
            "text" : "Certain but she but shyness why cottage. Gay the put instrument sir entreaties affronting. " +
                "Pretended exquisite see cordially the you. Weeks quiet do vexed or whose. Motionless if no to affronting " +
                "imprudence no precaution. My indulged as disposal strongly attended. Parlors men express had private village man. " +
                "Discovery moonlight recommend all one not. Indulged to answered prospect it bachelor is he bringing shutters. " +
                "Pronounce forfeited mr direction oh he dashwoods ye unwilling.\n" +
                "\n" +
                "Sportsman delighted improving dashwoods gay instantly happiness six. Ham now amounted absolute not mistaken way pleasant whatever." +
                " At an these still no dried folly stood thing. Rapid it on hours hills it seven years. If polite he active county in spirit an. " +
                "Mrs ham intention promotion engrossed assurance defective. Confined so graceful building opinions whatever trifling in. Insisted " +
                "out differed ham man endeavor expenses. At on he total their he songs. Related compact effects is on settled do.",
            "img" : "assets/svgs/logo.svg"
        },
        8 : {
            "id" : 8,
            "c-name" : "RandomCorp",
            "job-title" : "Full Stack",
            "occupation" : "Full-time",
            "email-address" : "randomcorp@jobs.com",
            "headline" : "What Makes You A Good Fit?",
            "salary" : "100,000 - 140,000 CHF",
            "text" : "Their could can widen ten she any. As so we smart those money in. Am wrote up whole so tears sense oh. " +
                "Absolute required of reserved in offering no. How sense found our those gay again taken the. Had mrs outweigh desirous sex overcame. " +
                "Improved property reserved disposal do offering me.\n" +
                "\n" +
                "From they fine john he give of rich he. They age and draw mrs like. Improving end distrusts may instantly was household applauded incommode." +
                " Why kept very ever home mrs. Considered sympathize ten uncommonly occasional assistance sufficient not. Letter of on become he tended active " +
                "enable to. Vicinity relation sensible sociable surprise screened no up as.",
            "img" : "assets/svgs/logo.svg"
        },
        9 : {
            "id" : 9,
            "c-name" : "RandomCorp",
            "job-title" : "Backend Developer",
            "occupation" : "part-time 60%-80%",
            "email-address" : "randomcorp@jobs.com",
            "headline" : "We want you!",
            "salary" : "100,000 - 140,000 CHF",
            "text" : "Up unpacked friendly ecstatic so possible humoured do. Ample end might folly quiet one set spoke her. " +
                "We no am former valley assure. Four need spot ye said we find mile. Are commanded him convinced dashwoods did estimable forfeited." +
                " Shy celebrated met sentiments she reasonably but. Proposal its disposed eat advanced marriage sociable. Drawings led greatest add subjects" +
                " endeavor gay remember. Principles one yet assistance you met impossible.\n" +
                "\n" +
                "Gay one the what walk then she. Demesne mention promise you justice arrived way. Or increasing to in especially" +
                " inquietude companions acceptance admiration. Outweigh it families distance wandered ye an. Mr unsatiable at" +
                " literature connection favourable. We neglected mr perfectly continual dependent.",
            "img" : "assets/svgs/logo.svg"
        }
    }

    let getData = (filter) => {
        data = filter;
    }

    let handlePanStart = (event) => {
        console.log(event)
        console.log(event.detail.deltaX)
        console.log(event.velocityX)
        if (event.detail.deltaX === 0) return;
        if (event.detail.center.x === 0 && event.detail.center.y === 0) return;
        console.log("this")

        let xMulti = event.detail.deltaX * 0.03;
        let yMulti = event.detail.deltaY / 80;
        let rotate = xMulti * yMulti;

        event.target.style.transform = 'translate(' + event.detail.deltaX + 'px, ' + event.detail.deltaY + 'px) rotate(' + rotate + 'deg)';
    }
    let handlePanEnd = (event, index) => {
        console.log("end")
        let moveOutWidth = document.body.clientWidth;
        let keep = Math.abs(event.detail.deltaX) < 80 || Math.abs(event.detail.velocityX) < 0.5;

        if (keep) {
            event.target.style.transform = '';
        } else {
            let endX = Math.max(Math.abs(event.detail.velocityX) * moveOutWidth, moveOutWidth);
            let toX = event.detail.deltaX > 0 ? endX : -endX;
            let endY = Math.abs(event.detail.velocityY) * moveOutWidth;
            let toY = event.detail.deltaY > 0 ? endY : -endY;
            let xMulti = event.detail.deltaX * 0.03;
            let yMulti = event.detail.deltaY / 80;
            let rotate = xMulti * yMulti;

            event.target.style.transform = 'translate(' + toX + 'px, ' + (toY + event.detail.deltaY) + 'px) rotate(' + rotate + 'deg)';

            if (event.detail.deltaX > 0) {
                handleDeniedSwipe(index);
            }
            else {
                handleAcceptedSwipe(index)
            }

        }
    }

    let handleDeniedSwipe = (index) => {
        console.log("Swipe Right")
        console.log(index)

        handleDecision(index);
    }
    let handleAcceptedSwipe = (index) => {
        console.log("Swipe Right")
        console.log(index)
        liked.push(items[index])

        handleDecision(index);
    }

    // TODO: Rename appropriately
    let handleDeniedBtn = (index) => {

        console.log("Swipe Left");
        console.log(index);

        let element = document.getElementById(index);

        if (!buttonsInline) {
            element.style.transition = 'all .3s ease';
            element.style.transform = "translate(-110%, 0) rotate(-10deg)";
        }
        else {
            detailView = -1;
            buttonsInline = false;
        }
        console.log("element", element)


        setTimeout(() => {
            handleDecision(index);
        }, 100);

    };

    // TODO: Rename appropriately
    let handleAcceptedBtn = (index) => {

        console.log("Swipe Left")
        console.log(index)
        liked.push(items[index])

        if (!buttonsInline) {
            let element = document.getElementById(index);
            element.style.transition = 'all .2s ease';
            element.style.transform = "translate(110%, 0) rotate(10deg)";
        }
        else {
            detailView = -1;
            buttonsInline = false;
        }



        setTimeout(() => {
            handleDecision(index);
        }, 100);


    };

    let handleDecision = (idx) => {

        delete items[idx];
        items = JSON.parse(JSON.stringify(items));
        console.log(items);

        // TODO(tomin): Check if index is valid before setting a new one
        if (currIndex >= 0) {
            currIndex -= 1;
        }

    };


   let currIndex = -1;

    let setIndex = (i) => {

        console.log('idx:', i);

        currIndex = i;

        return true;

    }
    let buttonsInline = false;

    let showDetails = (i) => {
        detailView = i;
        buttonsInline = true;

    }
    let hideDetails = () => {
        detailView = -1;
        buttonsInline = false;
    }


</script>

<Nav/>

<section>

    {#if !data}
        <Filter sendData="{getData}"/>
    {:else}
        {#if detailView < 0}
            {#each Object.entries(items) as item, i}
                <div
                        use:pan
                        on:pan={handlePanStart}
                        on:panend={() => handlePanEnd(event, i)}
                        on:click={() => showDetails(i)}
                        style="z-index: {i}; cursor=grabbing"
                        class="cards"
                        id="{i}">

                    {#if setIndex(i)}
                        <Cards filter_data="{data}" data="{item}" index="{i}"/>
                    {/if}

                </div>

            {/each}
        {:else}
            <section class="detail_container" on:click={hideDetails}>

                <div class="detail_wrapper">

                    <div class="logo">
                        <img src="{items[detailView]['img']}" alt="">
                    </div>
                    <div class="meta-data">
                        <h2>{items[detailView]['job-title']}</h2>
                        <span>{items[detailView]['occupation']}</span>
                        <span>{items[detailView]['salary']}</span>
                    </div>

                    <div class="headline">
                        <h2>{items[detailView]['headline']}</h2>
                    </div>

                    <div class="content-detail">
                        <span>{@html items[detailView]['text']}</span>
                    </div>


                </div>

            </section>

        {/if}



        {#if currIndex >= 0}
            <div class='buttons {buttonsInline ? "inFlow" : ""}' >

                <div>
                    <div class="denied"><img src="assets/svgs/close_red.svg" alt="" on:click={() => handleDeniedBtn(currIndex)}></div>
                </div>
                <div>
                    <div class="accepted"><img src="assets/svgs/confirm.svg" alt="" on:click={() => handleAcceptedBtn(currIndex)}></div>
                </div>

            </div>
        {/if}

        {#if Object.entries(items).length === 0}
            <div class="goTo_container">

                <div class="goTo">
                    <span>All done !</span>
                </div>
                <div class="goTo">
                    <a href="/liked">Go to liked Jobs</a>
                </div>

            </div>
        {/if}

    {/if}







</section>

<style>
    section {
        height: calc(100% - 7vh);
        /*height: 100%;*/
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow-y: scroll;
        width: 100%;
    }
    .cards {
        height: 100%;
        position: absolute;

        display: flex;
        justify-content: center;
    }

    .buttons {
        position: absolute;
        z-index: 100;
        bottom: 12vw;
        display: flex;
        width: 85%;
        justify-content: space-evenly;
    }
    .buttons div {
        padding: 3vw 0;
    }
    .buttons div div {
        padding: 5vw;
        border-radius: 100%;
        display: flex;
    }
    .accepted {
        border: 1px solid #44F63E;
    }
    .denied {
        border: 1px solid #E86464;
    }
    .buttons div div img {
        height: 6vw;
        width: 6vw;
    }
    .inFlow {
        position: relative;
        bottom: unset;

    }
    .goTo_container {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .goTo {
        margin-bottom: 8vw;
    }
    .goTo a, span {
        font-size: 5vw;
    }
    .detail_container {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;

    }
    .close img {
        height: 100%;
    }
    .detail_wrapper {
        width: 90%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 5vw;
    }
    .content-detail {
        white-space: pre-line;

    }
    .meta-data {
        display: flex;
        flex-direction: column;
        align-items: center;

    }
    .meta-data span {
        font-size: 3.5vw;
        font-weight: 500;
        margin: 1vw 0;

    }
    .headline {
        margin-top: 4vw;
        display: flex;
    }


</style>